module.exports = __webpack_public_path__ + "static/bpa75_ex1-4f110f2f8fe2851780c9baa22df1564f.png";